export default "__VITE_ASSET__Z9lFyqBi__"